<div class="rounded-1 justify-content-center frontends p-3 d-flex flex-fill">
  <h6 class="mx-3">{{ ('pages.frontend.' + frontend) | translate }}</h6>
  <p class="mb-0 badge text-uppercase" [ngClass]="{'status-badge-healthy': status === 'healthy', 'status-badge-warning' : status !== 'healthy'}">{{ ('common.text.service.status.' + status) | translate }}</p>
</div>
